import { simpleAxios } from "@/utils/http"
import { isRankingDisplayMode, type RankingDisplayMode } from "@/config/rankingDisplayModes"

type RankingDisplayData = {
    ranking_display_mode?: unknown
    ranking_mode?: unknown
    show_ranking?: unknown
}

export const getRankingDisplayMode = (data?: RankingDisplayData | null): RankingDisplayMode => {
    const rankingDisplayMode = data?.ranking_display_mode
    const legacyRankingMode = data?.ranking_mode

    if (isRankingDisplayMode(rankingDisplayMode)) {
        return rankingDisplayMode
    }

    if (isRankingDisplayMode(legacyRankingMode)) {
        return legacyRankingMode
    }

    if (data?.show_ranking === false) {
        return 'HIDDEN'
    }

    return 'NORMAL'
}

export const updateRankingDisplayMode = async (eventApiKey: string, mode: RankingDisplayMode) => {
    return simpleAxios("put", "events/event_full/" + eventApiKey, {
        ranking_display_mode: mode,
    })
}
